import { DataService } from "@data/data.service";
import { NotificationService } from "@notification/notification.service";
import { isNonEmptyArray } from "@util/utils";
import { Subscription } from "rxjs";
import { DocumentViewBase } from "./document-view-base";

export class SpecialDocumentBase extends DocumentViewBase {
  imgUrl = '';

  editUrl = '';

  signUrl = '';

  deviceSub!: Subscription;

  isLoading = false;
  dataLoaded = false;

  documentInfo:any;

  requestEditData(
    editUrl:string,
    dataService: DataService,
    notificationService: NotificationService,
    defaultError:string
  ) {
    this.isLoading = true;

    dataService.setDelay(editUrl, 2000);

    dataService.get(editUrl).subscribe((res: any) => {
      const result = res?.result;
      this.isLoading = false;

      if (result) {
        this.documentInfo = result;
        if (result.success) {
          if (isNonEmptyArray(result.pages)) {
            const firstPage = result.pages[0];
            if (firstPage?.data) {
              this.imgUrl = 'data:image/png;base64,' + firstPage.data;
              this.dataLoaded = true;
              return;
            }
          }
        }

        notificationService.showErrors([defaultError]);
      }
    }, (error: any) => {
      this.isLoading = false;
    });
  }
}
